import script from "./StatusTime.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusTime.vue?vue&type=script&setup=true&lang=js"

import "./StatusTime.vue?vue&type=style&index=0&id=08a7358c&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a7358c"]])

export default __exports__